import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, Tooltip } from "@fluentui/react-components";
import { Open16Regular } from "@fluentui/react-icons";
import FileTypeIcon from "./FileTypeIcon";
import EmbeddingStatusIcon from "./EmbeddingStatusIcon";
import ComboboxPathOptionText from "./ComboboxPathOptionText";
import { useActionButtonStyles } from "../styles/actionButtonStyles";

const useStyles = makeStyles({
  optionContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    width: "100%",
    minWidth: 0,
    gap: "8px",
  },
  optionIconDefault: {
    width: "14px",
    height: "14px",
    flexShrink: 0,
    color: "#569797",
    marginTop: "1px",
  },
  optionIconPdf: {
    width: "14px",
    height: "17px",
    flexShrink: 0,
    display: "block",
    marginTop: "1px",
  },
  optionIconWord: {
    width: "18px",
    height: "17px",
    flexShrink: 0,
    display: "block",
    marginTop: "1px",
  },
  optionName: {
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  statusIcon: {
    flexShrink: 0,
    marginTop: "1px",
  },
});

const FileResourceOption = ({ resource, onViewResource }) => {
  const styles = useStyles();
  const actionStyles = useActionButtonStyles();
  const [hovered, setHovered] = useState(false);

  const handleViewClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (typeof onViewResource === "function") {
      onViewResource(resource);
    }
  };

  return (
    <div
      className={styles.optionContent}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <FileTypeIcon
        fileName={resource.name}
        pdfClassName={styles.optionIconPdf}
        wordClassName={styles.optionIconWord}
        defaultClassName={styles.optionIconDefault}
      />
      <Tooltip
        content={
          resource.parentPath ? `${resource.name}\nFile Path: ${resource.parentPath}` : resource.name
        }
        relationship="label"
        withArrow
        showDelay={300}
        positioning="above"
      >
        <ComboboxPathOptionText
          name={resource.name}
          pathLabel="File Path"
          parentPath={resource.parentPath}
          nameClassName={styles.optionName}
        />
      </Tooltip>
      <EmbeddingStatusIcon embeddingStatus={resource.embedding_status} className={styles.statusIcon} />
      {typeof onViewResource === "function" && hovered && (
        <button type="button" className={actionStyles.viewActionButton} onClick={handleViewClick}>
          <Open16Regular className={actionStyles.viewActionIcon} />
          View
        </button>
      )}
    </div>
  );
};

FileResourceOption.propTypes = {
  resource: PropTypes.shape({
    connected_id: PropTypes.string,
    name: PropTypes.string,
    embedding_status: PropTypes.string,
    parentPath: PropTypes.string,
  }).isRequired,
  onViewResource: PropTypes.func,
};

export default FileResourceOption;
